exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description li p {\n  display: inline;\n}\n.min-h-474 {\n  min-height: 474px;\n}\n", ""]);

// exports
